// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1787216449991
      var cssReload = require("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./scss/style.scss
// module id = ./scss/style.scss
// module chunks = 0